import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { LayoutHelperService } from '../core/services/layout/layout-helper.service';
import { BannersModule } from '../lazy-modules/banners/banners.module';
import { VirtualEntryPointBannerComponent } from '../lazy-modules/virtualEntryPointBanner/virtual-entry-point-banner.component';
import { SrmQuickbetModule } from '../quickbet-srm/srm-quickbet.module';
import { SbModule } from '../sb/sb.module';
import { SharedModule } from '../shared/shared.module';
import { GreyhoundFutureTabComponent } from './components/greyhound/greyhoundFutureTab/greyhound-future-tab.component';
import { QuantumLeapComponent } from './components/quantumLeap/quantum-leap.component';
import { QuickNavigationComponent } from './components/quickNavigation/quick-navigation.component';
import { RacingAntepostTabComponent } from './components/racingAntepostTab/racing-antepost-tab.component';
import { RacingEnhancedMultiplesComponent } from './components/racingEnhancedMultiples/racing-enhanced-multiples.component';
import { RacingEventComponent } from './components/racingEventComponent/racing-event.component';
import { RacingEventMainComponent } from './components/racingEventMain/racing-event-main.component';
import { RacingEventResultedComponent } from './components/racingEventResultedComponent/racing-event-resulted.component';
import { RacingMainComponent } from './components/racingMain/racing-main.component';
import { RacingPostPickComponent } from './components/racingPostPick/racing-post-pick.component';
import { RacingSpecialsCarouselComponent } from './components/racingSpecialsCarousel/racing-specials-carousel.component';
import { RacingSpecialsTabComponent } from './components/racingSpecialsTab/racing-specials-tab.component';
import { RacingTabYourcallComponent } from './components/racingTabYourcall/racing-tab-yourcall.component';
import { RacingTabsMainComponent } from './components/racingTabsMain/racing-tabs-main.component';
import { GreyhoundsTabsComponent } from './components/racingTabsModule/greyhoundsTabs/greyhounds-tabs.component';
import { HorseracingTabsComponent } from './components/racingTabsModule/horseracingTabs/horseracing-tabs.component';
import { RacingYourcallSpecialsComponent } from './components/racingYourcallSpecials/racing-yourcall-specials.component';
import { SRMLoadingOverlayComponent } from './components/srmLoadingOverlay/loading-overlay-srm.component';
import { SrmMainComponent } from './components/srmMain/srm-main.component';
import { RacingRunService } from './services/racingRunService/racing-run.service';

@NgModule({
    declarations: [
        RacingYourcallSpecialsComponent,
        RacingSpecialsCarouselComponent,
        RacingSpecialsTabComponent,
        RacingEnhancedMultiplesComponent,
        RacingAntepostTabComponent,
        HorseracingTabsComponent,
        GreyhoundsTabsComponent,
        RacingEventComponent,
        QuickNavigationComponent,
        QuantumLeapComponent,
        RacingTabYourcallComponent,
        RacingMainComponent,
        RacingTabsMainComponent,
        RacingEventMainComponent,
        RacingEventResultedComponent,
        GreyhoundFutureTabComponent,
    ],
    exports: [
        RacingYourcallSpecialsComponent,
        RacingSpecialsCarouselComponent,
        RacingSpecialsTabComponent,
        RacingEnhancedMultiplesComponent,
        HorseracingTabsComponent,
        RacingAntepostTabComponent,
        QuantumLeapComponent,
        GreyhoundsTabsComponent,
        RacingTabYourcallComponent,
        RacingMainComponent,
        RacingTabsMainComponent,
        RacingEventMainComponent,
        RacingPostPickComponent,
        // DailyRacingModuleComponent,
        QuickNavigationComponent,
        GreyhoundFutureTabComponent,
    ],
    schemas: [NO_ERRORS_SCHEMA],
    imports: [
        SharedModule,
        SbModule,
        BannersModule,
        SrmMainComponent,
        SRMLoadingOverlayComponent,
        SrmQuickbetModule,
        RacingPostPickComponent,
        VirtualEntryPointBannerComponent,
    ],
    providers: [RacingRunService, provideHttpClient(withInterceptorsFromDi()), LayoutHelperService],
})
export class RacingModule {
    constructor(racingRunService: RacingRunService) {
        racingRunService.run();
    }
}
